import { render, staticRenderFns } from "./PlanoCliente.vue?vue&type=template&id=5bec604a"
import script from "./PlanoCliente.vue?vue&type=script&lang=js"
export * from "./PlanoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports